import { Injectable } from '@angular/core';
import * as ZXing from '@zxing/library';

import {
  MultiFormatReader,
  BarcodeFormat,
  DecodeHintType,
  RGBLuminanceSource,
  BinaryBitmap,
  HybridBinarizer,
} from '@zxing/library';
import { ProcessedImage } from './processed-image.interface';

// Supported barcode formats
const formats = [
  // 1D code formats
  BarcodeFormat.CODE_39,
  BarcodeFormat.EAN_13,
  // 2D code formats
  BarcodeFormat.QR_CODE,
  BarcodeFormat.DATA_MATRIX,
];

@Injectable({
  providedIn: 'root',
})
export class ZxingService {
  async processImage(canvas: HTMLCanvasElement, width: number, height: number): Promise<ProcessedImage> {
    const startTime = Date.now();
    let result = '';

    const context = canvas.getContext('2d');
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);

    const hints = new Map();
    hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);
    hints.set(DecodeHintType.TRY_HARDER, true);
    try {
      // Set up reader with hints
      const reader = new MultiFormatReader();
      reader.setHints(hints);

      const luminanceSource = new RGBLuminanceSource(imageData.data, width, height);
      const binaryBitmap = new BinaryBitmap(new HybridBinarizer(luminanceSource));

      // Decode the barcode
      result = reader.decode(binaryBitmap).getText();
    } catch (error) {
      console.log('Error in zxing', error);
      result = 'Error: ' + error.message;
    } finally {
      const timeSeconds = Math.round(Date.now() - startTime) / 1000;

      return {
        result,
        time: timeSeconds,
      };
    }
  }
}
